<template>
  <!-- 外面的快捷选项 只有3个 昨天 今天  明天 -->
  <el-date-picker
    v-model="timeDate"
    type="datetimerange"
    align="right"
    unlink-panels
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :picker-options="pickerOptions"
    :on-pick="onPick"
    :clearable="clearable"
    v-bind="$attrs"
    format="yyyy-MM-dd HH:mm:ss"
    value-format="yyyy-MM-dd HH:mm:ss"
    v-on="$listeners"
    @change="onDateChange"
  />
</template>

<script>
import { getFutureDaysRange, getYesterdayRange, getLastSevenDaysRange, getWeekDateRange, getCurrentDateRange  } from '@/utils/date'
import dayjs from 'dayjs'

export default {
  name: 'BaseDateTimeRange',
  props: {
    // [开始日期，结束日期]
    value: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: (time) => {
        return time.getTime() > Date.now()
      }
    },
    clearable: {
      type: Boolean,
      default: false
    },
    beginTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    // 快捷选项默认
    shortcutsLayout: {
      type: Array,
      default: () => ['today', 'lastDay', '7day', '30day', 'week', 'lastWeek', 'month', 'lastMonth']
    }
  },
  data () {
    return {
      timeDate: [],
      today: {
        text: '今天',
        onClick: (picker) => {
          const range = getCurrentDateRange()
          console.log('range', this.getShortcutTime(range))

          picker.$emit('pick', this.getShortcutTime(range, '00:00:00', dayjs().format('HH:mm:ss')))
        }
      },
      lastDay: {
        text: '昨天',
        onClick: (picker) => {
          const range = getYesterdayRange()
          picker.$emit('pick', this.getShortcutTime(range))
        }
      },
      '7day': {
        text: '过去7天',
        onClick: (picker) => {
          const range = getLastSevenDaysRange()
          picker.$emit('pick', this.getShortcutTime(range))
        }
      },
      '30day': {
        text: '过去30天',
        onClick: (picker) => {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
          picker.$emit('pick', this.getShortcutTime([start, end]))
        }
      },
      week: {
        text: '本周',
        onClick: (picker) => {
          const range = getWeekDateRange('YYYY-MM-DD HH:mm:ss')
          picker.$emit('pick', this.getShortcutTime(range, '00:00:00', dayjs().format('HH:mm:ss')))
        }
      },
      lastWeek: {
        text: '上周',
        onClick: (picker) => {
          const dataValue = new Date()
          const year = dataValue.getFullYear()
          const month = dataValue.getMonth() + 1
          const day = dataValue.getDate()
          let thisWeekStart // 本周周一的时间
          if (dataValue.getDay() === 0) {
            // 周天的情况；
            thisWeekStart = new Date(year + '/' + month + '/' + day).getTime() - (dataValue.getDay() + 6) * 86400000
          } else {
            thisWeekStart = new Date(year + '/' + month + '/' + day).getTime() - (dataValue.getDay() - 1) * 86400000
          }
          const prevWeekStart = thisWeekStart - 7 * 86400000 // 上周周一的时间
          const prevWeekEnd = thisWeekStart - 1 * 86400000 // 上周周日的时间
          const start = new Date(prevWeekStart) // 开始时间
          const end = new Date(prevWeekEnd) // 结束时间
          picker.$emit('pick', this.getShortcutTime([start, end]))
        }
      },
      month: {
        text: '本月',
        onClick: (picker) => {
          const end = new Date()
          const start = new Date()
          start.setDate(1)
          picker.$emit('pick', this.getShortcutTime([start, end], '00:00:00', dayjs().format('HH:mm:ss')))
        }
      },
      lastMonth: {
        text: '上月',
        onClick: (picker) => {
          function gettimeStart () {
            const nowdays = new Date()
            let year = nowdays.getFullYear()
            let month = nowdays.getMonth()
            if (month === 0) {
              month = 12
              year = year - 1
            }
            if (month < 10) {
              month = '0' + month
            }
            let firstDayOfPreMonth = year + '-' + month + '-' + '01'
            firstDayOfPreMonth = firstDayOfPreMonth.toString()
            return new Date(firstDayOfPreMonth)
          }
          function gettimeEnd () {
            const nowdays = new Date()
            let year = nowdays.getFullYear()
            let month = nowdays.getMonth()
            if (month === 0) {
              month = 12
              year = year - 1
            }
            if (month < 10) {
              month = '0' + month
            }
            const lastDay = new Date(year, month, 0)
            let lastDayOfPreMonth = year + '-' + month + '-' + lastDay.getDate()
            lastDayOfPreMonth = lastDayOfPreMonth.toString()
            return new Date(lastDayOfPreMonth)
          }
          const end = gettimeEnd()
          const start = gettimeStart()
          picker.$emit('pick', this.getShortcutTime([start, end]))
        }
      }
    }
  },
  computed: {
    // 时间快捷选项
    shortcuts () {
      const shortcuts = this.shortcutsLayout.map(key => this[key])
      return shortcuts
    },
    pickerOptions () {
      return {
        disabledDate: this.disabledDate,
        shortcuts: this.shortcuts.length ? this.shortcuts : false
      }
    }
  },
  watch: {
    value: {
      handler: function (value) {
        this.timeDate = value
      },
      deep: true,
      immediate: true
    },
    timeDate: {
      handler: function (timeDate) {
        const value = timeDate || []
        this.$emit('input', value)
        this.$emit('update:beginTime', value[0] || '')
        this.$emit('update:endTime', value[1] || '')
      },
      deep: true
    }
  },
  methods: {
    /**
     * @description 选中日期后会执行的回调，
     */
    onPick (timeDate) {
      console.log('onPick', timeDate)
    },
    /**
     * @description date change事件
     */
    onDateChange (timeDate) {
      this.$emit('change', timeDate,this)
    },

    // 处理快捷键的开始时间和结束时间
    getShortcutTime (range, begin = '00:00:00', end = '23:59:59') {
      // 快捷键触发的，正常情况下应该都会有值的
      const beginTime = begin ? begin : '00:00:00'
      const endTime = end ? end : '23:59:59'
      if (range && range.length) {
        return [`${dayjs(range[0]).format('YYYY-MM-DD')} ${beginTime}`, `${dayjs(range[1]).format('YYYY-MM-DD')} ${endTime}`]
      }
      return range
    }
  }
}
</script>
